import {
    FETCH_USER_GROUPS_AREAS,
    FETCH_USER_GROUPS_AREAS_ERROR,
    FETCH_USER_GROUPS_AREAS_SUCCESS,
    UserGroupsAreasActionTypes,
    FETCH_USER_GROUPS_AREAS_VIEWS,
    FETCH_USER_GROUPS_AREAS_VIEWS_ERROR,
    FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS
} from "../../actions/user-groups/UserGroupAreasActions";

import { UserGroupAssociatedArea } from "../../models/user-groups/UserGroup"
import { RequestState } from "../../models/common/RequestState";
import { View } from "../../models/common/ViewSettings";

export interface UserGroupsAreasState {

    userGroupAreas: {
        totalEntries: number
        entries: UserGroupAssociatedArea[]
    }
    areaViews: { 
        [ key: number ]:  {
            [key: number]: {
                views: View[]
            }
        }
    }
    request: RequestState
}

const initialState: UserGroupsAreasState = {

    userGroupAreas: {
        totalEntries: 0,
        entries: []
    },
    areaViews: {},
    request: { error: null, isFetching: false, lastRequestSuccess: 0 }
};

export const UserGroupsAreasReducer = ( state = initialState, action: UserGroupsAreasActionTypes  ): UserGroupsAreasState => {
    switch( action.type ) {
        case FETCH_USER_GROUPS_AREAS:
                return {
                    ...state,
                    request: {
                        error: null,
                        isFetching: true,
                        lastRequestSuccess: 0
                    }
                };
        case FETCH_USER_GROUPS_AREAS_SUCCESS:
            return {
                ...state,
                userGroupAreas: action.areas,
                request: {
                    isFetching: false,
                    error: null,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_USER_GROUPS_AREAS_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        case FETCH_USER_GROUPS_AREAS_VIEWS:
                return {
                    ...state,
                    request: {
                        error: null,
                        isFetching: true,
                        lastRequestSuccess: 0
                    }
                };
        case FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS:
                return {
                    ...state,
                    areaViews: {
                        ...state.areaViews,
                        [ action.userGroupId ]: {
                            ...state.areaViews[ action.userGroupId],
                            [ action.areaId ]: {
                                views: action.payload
                            }
                        }
                    },
                    request: {
                        isFetching: false,
                        error: null,
                        lastRequestSuccess: Date.now()
                    }
                };
        case FETCH_USER_GROUPS_AREAS_VIEWS_ERROR:
                return {
                    ...state,
                    request: {
                        isFetching: false,
                        lastRequestSuccess: 0,
                        error: action.error
                    }
                };               
        default:
            return state;
    }
};